// Single score→color-band source for the legacy main-app React components.
// Canonical bands (PRD 12, decided 2026-06-23): red <=50, yellow 51–75, green >=76.
// The shared @sitzkrieger/healthscore-cockpit package carries the same values;
// once every consumer builds the package from live source these copies can be
// replaced by importing scoreToBand from the package.
export const RED_UPPER_BOUND = 50;
export const YELLOW_UPPER_BOUND = 75;
export function scoreToBand(score) {
    if (score <= RED_UPPER_BOUND)
        return 'red';
    if (score <= YELLOW_UPPER_BOUND)
        return 'yellow';
    return 'green';
}
